var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "../_snowpack/pkg/react.js";

function SvgIconLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 727 728"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M524.4 363.8L363.2 202.4 202 363.8l161.2 161.4 161.2-161.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M363.1 44.9l318.3 318.7-318.3 318.8L44.9 363.7 363.1 44.9zm0-44.9l-22.4 22.5L22.4 341.2 0 363.7l22.4 22.5 318.3 318.7 22.4 22.5 22.4-22.5 318.3-318.7 22.4-22.5-22.4-22.5L385.6 22.5 363.1 0z"
  })));
}

export default SvgIconLogo;